import { OrderFormRestorationType } from 'models/order-form';
import { SimpleSubCategory } from 'models/order-input/simple-order';

export const cateogryMap: Record<string, SimpleSubCategory> = {
    [OrderFormRestorationType.CROWN]: SimpleSubCategory.SINGLE_CROWN,
    [OrderFormRestorationType.BRIDGE]: SimpleSubCategory.BRIDGE,
    [OrderFormRestorationType.POST]: SimpleSubCategory.OTHER,
    [OrderFormRestorationType.IMPLANT_CROWN]: SimpleSubCategory.IMPLANT_CROWN,
    [OrderFormRestorationType.IMPLANT_BRIDGE]: SimpleSubCategory.IMPLANT_BRIDGE,
    [OrderFormRestorationType.PARTIAL_DENTURE]: SimpleSubCategory.PARTIAL_DENTURE,
    [OrderFormRestorationType.FULL_DENTURE]: SimpleSubCategory.COMPLETE_DENTURE,
    [OrderFormRestorationType.RETENTION]: SimpleSubCategory.OTHER,
    [OrderFormRestorationType.CLASP_PLATE]: SimpleSubCategory.OTHER,
    [OrderFormRestorationType.GROWTH_ADAPTATION]: SimpleSubCategory.OTHER,
    [OrderFormRestorationType.ANCHORAGE]: SimpleSubCategory.OTHER,
    [OrderFormRestorationType.EXPANSION]: SimpleSubCategory.OTHER,
    [OrderFormRestorationType.ANTIAPNEA]: SimpleSubCategory.OTHER_REMOVABLE,
    [OrderFormRestorationType.SPLINT]: SimpleSubCategory.BITETRAY,
};

export const materialMap: Record<string, string> = {
    ZIRCONIA: 'Zirconia',
    EMAX: 'Lithium Disilicate',
    EMPRESS: 'Empress',
    PFM_COCR: 'MK-CoCr',
    COCR_ACRYLIC: 'CoCr',
    COCR_PORCELAIN: 'Porslin',
    COCR_COMPOSITE: 'COCR_COMPOSITE',
    ACRYLATE: 'Akryl',
    COMPOSITE: 'CoCr',
    MK_TITANIUM: 'MK-Titan',
    MK_GOLD: 'MK-Guld',
    COCR: 'CoCr',
    GOLD: 'Guld',
    VALPLAST: 'Valplast',
    THERMOPLAST: 'Akryl',
};
